// extracted by mini-css-extract-plugin
export default {"container":"badges_container__elZyh","titleWrap":"badges_titleWrap__uYAku","badgesWrap":"badges_badgesWrap__NrEFp","overlay":"badges_overlay__BrORs"};